const MS_BASE_PATH = {
	blog: 'blog',
	calendar: 'calendar',
	coins: 'coins',
	diary: 'diary',
	gifts: 'gifts',
	media: 'media',
	member: 'member',
	profile: 'profile',
	tracking: 'tracking',
	trust: 'trust',
	contest: 'contests',
	missions: 'missions',
	ocr: 'ocr'
} as const

const PAGES_QUERY_CLIENT_STALE_TIME = 5 * 60 * 1000

const POST_TYPE = {
	article: 'article',
	image: 'image',
	regulation: 'regulation',
	video: 'video'
} as const

const ROLES = {
	admin: 'admin',
	manager: 'manager',
	service: 'service',
	tech: 'tech'
} as const

const TAG_AGE_RANGE = [
	{ slug: '14-17', title: '14-17' },
	{ slug: '18-24', title: '18-24' },
	{ slug: '25-34', title: '25-34' },
	{ slug: '35-44', title: '35-44' },
	{ slug: '45+', title: '45+' }
]

const TAG_INTERESTS = [
	{ slug: 'contraception', title: 'Contraccezione' },
	{ slug: 'education', title: 'Educazione sessuale' },
	{ slug: 'fashion', title: 'Moda e lifestyle' },
	{ slug: 'first-time', title: 'La prima volta' },
	{ slug: 'fitness', title: 'Fitness' },
	{ slug: 'gynecology', title: 'Visita dalla ginecologa' },
	{ slug: 'makeup', title: 'Make-up' },
	{ slug: 'mental', title: 'Benessere mentale' },
	{ slug: 'nutrition', title: 'Alimentazione' },
	{ slug: 'pregnancy', title: 'Gravidanza' },
	{ slug: 'questions', title: 'Domande imbarazzanti' },
	{ slug: 'skincare', title: 'Skincare e dermatologia' },
	{ slug: 'sport', title: 'Sport e fitness' }
]

const TAG_MENSTRUAL_CYCLE_STATUS = [
	{ slug: 'pre-cycle', title: 'Pre-ciclo' },
	{ slug: 'cycle', title: 'Durante il ciclo' },
	{ slug: 'post-cycle', title: 'Post-ciclo' },
	{ slug: 'ovulation', title: 'Ovulazione' }
]

const TAGS = [
	{ label: 'Interessi', options: TAG_INTERESTS },
	{ label: "Fascia d'età", options: TAG_AGE_RANGE },
	{ label: 'Stato ciclo', options: TAG_MENSTRUAL_CYCLE_STATUS }
]

export { MS_BASE_PATH, PAGES_QUERY_CLIENT_STALE_TIME, POST_TYPE, ROLES, TAGS }
